module.exports = __webpack_public_path__ + "static/media/my_choices.97bf91d9.jpg";